import ModelMappingValueOriginObjectModelProperty from "~/models/mapping/modelMappingValueOriginObjectModelProperty";
import ModelMappingValueOriginFormElement from "~/models/mapping/modelMappingValueOriginFormElement";
import {isDataTypeIncompatible} from "~/models/mapping/dataTypeConcerns/otherSideFunctions";

export function areMappingDataTypesCompatible(source, destination) {
  let thisSide, otherSide;

  if (source instanceof ModelMappingValueOriginFormElement || destination instanceof ModelMappingValueOriginFormElement) {
    if (source instanceof ModelMappingValueOriginFormElement) {
      [thisSide, otherSide] = [source, destination];
    } else [thisSide, otherSide] = [destination, source];
  } else if (source instanceof ModelMappingValueOriginObjectModelProperty || destination instanceof ModelMappingValueOriginObjectModelProperty) {
    if (source instanceof ModelMappingValueOriginObjectModelProperty) {
      [thisSide, otherSide] = [source, destination];
    } else [thisSide, otherSide] = [destination, source];
  } else return true;

  if (thisSide && otherSide) return !isDataTypeIncompatible(thisSide, otherSide)
  return true;
}